import { useState, useEffect, useCallback, useRef } from 'react';
import { updateStudyTime } from '../api/learningStats';

// 학습 시간을 추적하는 훅 (디버깅용 로그 포함)
const useStudyTimeTracker = () => {
  const [isTracking, setIsTracking] = useState(false);
  const [elapsedMinutes, setElapsedMinutes] = useState(0);
  const startTimeRef = useRef(null);
  const intervalRef = useRef(null);
  const accumulatedTimeRef = useRef(0); // 누적 학습 시간
  const lastSaveTimeRef = useRef(0); // 마지막 저장 시간

  // 학습 시간 추적 시작
  const startTracking = useCallback(() => {
    console.log('startTracking 호출됨');
    if (isTracking) return;
    startTimeRef.current = new Date();
    setIsTracking(true);
    intervalRef.current = setInterval(() => {
      const now = new Date();
      const elapsed = Math.floor((now - startTimeRef.current) / 60000); // 분 단위
      setElapsedMinutes(elapsed);
      // 30분마다 자동 저장
      if (elapsed - lastSaveTimeRef.current >= 30) {
        updateStudyTime(30)
          .then(() => {
            console.log('학습 시간 자동 저장: 30분');
            lastSaveTimeRef.current = elapsed;
          })
          .catch(error => {
            console.error('학습 시간 자동 저장 실패:', error);
          });
      }
    }, 60000); // 1분마다 체크
    console.log('학습 시간 추적 시작');
  }, [isTracking]);

  // 학습 시간 추적 중지 및 저장
  const stopTracking = useCallback(async () => {
    console.log('stopTracking 호출됨');
    console.log('stopTracking 상태:', { intervalRef: intervalRef.current, isTracking, elapsedMinutes });
    if (!isTracking) return 0;
    clearInterval(intervalRef.current);
    const now = new Date();
    const minutesSinceStart = Math.max(1, Math.floor((now - startTimeRef.current) / 60000));
    const minutesSinceLastSave = minutesSinceStart - lastSaveTimeRef.current;
    setIsTracking(false);
    setElapsedMinutes(0);
    accumulatedTimeRef.current += minutesSinceStart;
    // 마지막 저장 이후 경과한 시간만 저장
    if (minutesSinceLastSave > 0) {
      try {
        await updateStudyTime(minutesSinceLastSave);
        console.log(`${minutesSinceLastSave}분 학습 시간 저장 완료`);
        lastSaveTimeRef.current = 0;
      } catch (error) {
        console.error('학습 시간 저장 실패:', error);
      }
    }
    return minutesSinceStart;
  }, [isTracking]);

  // 언마운트 시 자동 저장
  useEffect(() => {
    return () => {
      if (isTracking) {
        stopTracking();
      }
    };
  }, [isTracking, stopTracking]);

  useEffect(() => {
    console.log('isTracking:', isTracking, 'elapsedMinutes:', elapsedMinutes);
  }, [isTracking, elapsedMinutes]);

  return {
    isTracking,
    elapsedMinutes,
    totalAccumulated: accumulatedTimeRef.current,
    startTracking,
    stopTracking
  };
};

export default useStudyTimeTracker;